// These function are used by route `onEnter` handlers to map route state to library/resource/path store state

const getSection = (section) => {
  const defaultSection = "about"
  const previousSection = App.getStore("resource").previous("section")
  const sections = ["about", "path", "community"]

  if (!sections.includes(section)) {
    return previousSection || defaultSection
  }
  return section
}

export const loadResource = async function (nextState, replaceState /* ? */) {
  const { resourceSlug, cohortId, section } = nextState.match.params
  const resourceStore = window.App.getStore("resource")
  const result = await resourceStore.action.selectResourceBySlug(
    resourceSlug,
    cohortId,
    getSection(section)
  ).promise

  const { resource } = resourceStore.getState()

  // The resource slug in the URL may not match the resource.slug.
  // This could be due to the resource slug being incomplete
  // (may just be the resource.id).
  // NOTE: this same behavior is handled by the backend, but sometimes
  // the client uses internal links that only include the resource.id.
  // These are the cases this client-side solution addresses.
  if (
    resource &&
    resource.slug !== resourceSlug &&
    resource.id == resourceSlug &&
    replaceState
  ) {
    // For semantics, lets redirect to the <resource_slug>-<id> slug
    // when the resource slug doesn't match.
    if (resource.id == resourceSlug) {
      const nextResourceSlug = `${resource.slug}-${resource.id}`
      const pathname = location.pathname.replace(resourceSlug, nextResourceSlug)
      return replaceState({
        ...location,
        pathname
      })
    }
  }

  return result
}

// The expection here is that any route needing to load the path will also be using a component
// wrapped with the PathProvider which handles loading the path. Here, we simply need to resolve a promise once the path store has the path.
const loadPath = () => {
  return new Promise((resolve, reject) => {
    const { offering } = App.getStore("resource").getState()
    const { path } = App.getStore("path").getState()
    // Ensure we aren't proceeding with a path intended for some
    // other cohort.
    if (path && path.offering_id === offering.id) {
      resolve(path)
    } else {
      App.listenToOnce(App.getStore("path"), "change:path", () =>
        resolve(App.getStore("path").getState().path)
      )
    }
  })
}

export const loadResourcePath = function (nextState, replaceState /* ? */) {
  return loadResource(nextState, replaceState).then(loadPath)
}

export const loadResourcePathStep = function (nextState) {
  const { pathItemSourceId } = nextState.match.params
  return loadResourcePath(nextState).then(() =>
    window.App.getStore("step").action.setSelectedStepByID(pathItemSourceId)
  )
}

export const loadResourcePathLesson = function (nextState) {
  const { pathItemSourceId } = nextState.match.params
  return loadResourcePath(nextState).then(() =>
    window.App.getStore("path").action.selectGroupByID(pathItemSourceId)
  )
}
